import { render, staticRenderFns } from "./EditUserPrivileges.vue?vue&type=template&id=a4b1c08e&scoped=true&"
import script from "./EditUserPrivileges.vue?vue&type=script&lang=js&"
export * from "./EditUserPrivileges.vue?vue&type=script&lang=js&"
import style0 from "./EditUserPrivileges.vue?vue&type=style&index=0&id=a4b1c08e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4b1c08e",
  null
  
)

export default component.exports